import moment from 'moment';
import { isValidDate, MOMENT_SUPPORTED_DATE_FORMATS } from 'utilities';

export const parseCellDate = (dateValue?: string): Date | null => {
  if (!dateValue || !isValidDate(dateValue)) {
    return null;
  }
  return moment(dateValue, MOMENT_SUPPORTED_DATE_FORMATS).toDate();
};

export const resolveDateFromEditValue = (editValue: string | undefined, cellValue: unknown): Date | null => {
  if (editValue !== undefined) {
    if (editValue === '') {
      return null;
    }
    return parseCellDate(editValue);
  }
  if (cellValue) {
    return parseCellDate(cellValue as string);
  }
  return null;
};
